import dvrsService from 'services/dvrsService';

declare global {
  interface Window {
    dataLayer?: any[];
  }
}

export const appAnalyticsName = 'Kiosk check-in';

export type TrackingEvent = {
  event?: string;
  action: string;
  label?: string;
  data?: Record<string, unknown>;
  category?: string;
};

export const trackLegacyEvent = ({ category, action, label }: TrackingEvent): void => {
  // note - need to handle when dataLayer not initialised - for dev
  (window.dataLayer || []).push({
    event: 'event',
    eventProps: {
      category,
      action,
      label
    }
  });
};

export const trackEvent = async ({
  event,
  action,
  label,
  category,
  data = {}
}: TrackingEvent): Promise<void> => {
  // note - need to handle when dataLayer not initialised - for dev

  (window.dataLayer || []).push({
    event: event || 'custom.kioskcheckin',
    category: category ?? appAnalyticsName,
    action,
    label,
    data: {
      ...data,
      deviceFingerprint: await dvrsService.getDeviceFP()
    }
  });
};
